import { render, staticRenderFns } from "./ImportantMessages.vue?vue&type=template&id=a928c7cc&scoped=true"
import script from "./ImportantMessages.vue?vue&type=script&lang=js"
export * from "./ImportantMessages.vue?vue&type=script&lang=js"
import style0 from "./ImportantMessages.vue?vue&type=style&index=0&id=a928c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a928c7cc",
  null
  
)

export default component.exports